module.exports = __webpack_public_path__ + "static/media/hugo-boss-dark-blue-big.f92ec8df.png";